/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import InputLabel from "@mui/material/InputLabel";
import {
  UploadImage,
  TextInputComponent,
  SelectInputComponent,
  RevenueInputComponent,
  CountryCodeWithPhoneNumber,
  DescriptionInputComponent,
} from "../../../common/components";
import {
  LEAD_STATUS_OPTIONS,
  LEAD_SOURCE_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  LEAD_OWNER_OPTIONS,
  RATING_OPTIONS,
  INTERESTED_PRODUCT_OPTIONS,
} from "../../../constants/leadDropdown";
import leadInfoIcon from "../../../assets/icons/leadInfo.svg";
import OwnerIcon from "../../../assets/icons/owner.svg";
import "./create-lead-capture-form.scss";

const LeadCaptureFormElements = (props: any) => {
  const { data } = props;

  return (
    <>
      <div>
        {data?.title === "uploadPhoto" ? (
          <div
            className="lead-capture-form-main-element-section-photo"
            style={{ pointerEvents: "none" }}
          >
            <UploadImage
              label={data?.isRequired ? "Upload Photo *" : "Upload Photo"}
              text="Photo"
              value={""}
              onChange={() => {}}
              onClick={() => {}}
              showCloseButton
              handleClose={() => {}}
            />
          </div>
        ) : data?.title === "firstName" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="firstName"
              label="First Name"
              placeholder="Enter First Name"
              optional={true}
              disabled={false}
              value={""}
              isRequired={data?.isRequired}
              isName={true}
              maxlength="50"
            />
          </div>
        ) : data?.title === "middleName" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="middleName"
              label="Middle Name "
              placeholder="Enter Middle Name"
              isRequired={data?.isRequired}
              optional={data?.isRequired}
              disabled={false}
              value={""}
              isName={true}
              maxlength="50"
            />
          </div>
        ) : data?.title === "lastName" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="lastName"
              label="Last Name"
              placeholder="Enter Last Name"
              optional={true}
              disabled={false}
              value={""}
              isRequired={data?.isRequired}
              isName={true}
              maxlength="50"
            />
          </div>
        ) : data?.title === "leadOwner" ? (
          <div className="lead-capture-form-main-element-section">
            <SelectInputComponent
              fieldName="leadOwner"
              label="Lead Owner"
              options={LEAD_OWNER_OPTIONS}
              onChange={props?.setSelectedLeadOwner}
              value={props?.selectedLeadOwner}
              placeholder="Enter lead owner"
              icon={OwnerIcon}
              optional={data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "leadSource" ? (
          <div className="lead-capture-form-main-element-section">
            <SelectInputComponent
              fieldName="leadSource"
              label="Lead Source"
              options={LEAD_SOURCE_OPTIONS}
              onChange={(e: any) => {}}
              value={null}
              placeholder="Enter lead source"
              icon={OwnerIcon}
              optional={data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "leadStatus" ? (
          <div className="lead-capture-form-main-element-section">
            <SelectInputComponent
              fieldName="leadStatus"
              label="Lead Status"
              options={LEAD_STATUS_OPTIONS}
              onChange={(e: any) => {}}
              value={null}
              placeholder="Enter lead status"
              icon={OwnerIcon}
              optional={data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "rating" ? (
          <div className="lead-capture-form-main-element-section">
            <SelectInputComponent
              fieldName="rating"
              label="Confidence Score"
              options={RATING_OPTIONS}
              onChange={(e: any) => {}}
              value={null}
              placeholder="Select Confidence Score"
              colorProp={true}
              closeIcon
              onClear={() => props?.setSelectedRating("")}
              optional={data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "interestedProduct" ? (
          <div className="lead-capture-form-main-element-section">
            <SelectInputComponent
              fieldName="interestedProduct"
              label="Interested Product"
              options={INTERESTED_PRODUCT_OPTIONS}
              onChange={(e: any) => {}}
              value={null}
              placeholder=" Select Interested Product"
              optional={data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "leadValue" ? (
          <div className="lead-capture-form-main-element-section">
            <RevenueInputComponent
              fieldName="leadValue"
              label="Lead Value ($)"
              placeholder="Enter Revenue amount"
              optional={data?.isRequired}
              disabled={false}
              value={""}
              logo={leadInfoIcon}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "age" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="age"
              label="Age (years)"
              placeholder="Enter Age (years)"
              optional={data?.isRequired}
              value={""}
              isName={false}
              allowSpecialCharacters={true}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "maritalStatus" ? (
          <div className="lead-capture-form-main-element-section">
            <SelectInputComponent
              fieldName="maritalStatus"
              label="Marital Status"
              options={MARITAL_STATUS_OPTIONS}
              onChange={(e: any) => {}}
              value={null}
              placeholder="Select Marital Status"
              icon={OwnerIcon}
              optional={data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "preferredContactMode" ? (
          <div className="lead-capture-form-main-element-section">
            <SelectInputComponent
              fieldName="preferredContactMode"
              label="Preferred Contact Mode"
              options={[
                "Email",
                "Phone Call",
                "In-Person Meeting",
                "No Preference",
              ]}
              onChange={(e: any) => {}}
              value={null}
              placeholder="Select Preferred Contact Mode"
              // icon={OwnerIcon}
              optional={data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "secondaryPhoneNumber" ? (
          <div className="lead-capture-form-main-element-section">
            <CountryCodeWithPhoneNumber
              fieldName="secondaryPhoneNumber"
              label="Secondary Phone Number"
              placeholder={"Enter Secondary Phone Number"}
              value={""}
              optional={!data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "primaryPhoneNumber" ? (
          <div className="lead-capture-form-main-element-section lead-capture-form-main-element-section-phone">
            <CountryCodeWithPhoneNumber
              fieldName="primaryPhoneNumber"
              label="Primary Phone Number"
              placeholder={"Enter Primary Phone Number"}
              value={""}
              optional={!data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "email" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="email"
              fieldName="email"
              label="Email"
              placeholder="Enter Email"
              optional={true}
              disabled={false}
              value={""}
              onChange={(e: any) =>
                props?.setFieldValue("email", e?.target?.value)
              }
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "secondaryEmail" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="secondaryEmail"
              fieldName="secondaryEmail"
              label="Secondary Email"
              placeholder="Enter Secondary Email"
              optional={data?.isRequired}
              disabled={false}
              value={""}
              onChange={(e: any) =>
                props?.setFieldValue("email", e?.target?.value)
              }
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "website" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="Website"
              fieldName="website"
              label="Website"
              placeholder="Enter Website"
              optional={data?.isRequired}
              disabled={false}
              value={""}
              maxlength="500"
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "company" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="company"
              fieldName="company"
              label="Company"
              placeholder="Enter Company"
              optional={data?.isRequired}
              disabled={false}
              value={""}
              maxlength="100"
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "fax" ? (
          <div className="lead-capture-form-main-element-section">
            <CountryCodeWithPhoneNumber
              fieldName="fax"
              label="Fax"
              placeholder={"Enter Fax Number"}
              value={"+1"}
              defaultCountry="us"
              optional={!data?.isRequired}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "industry" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              label="Industry"
              fieldName="industry"
              value={""}
              placeholder="Enter Industry"
              optional={data?.isRequired}
              disabled={false}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "designation" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="designation"
              label="Designation"
              placeholder="Enter Designation"
              optional={data?.isRequired}
              disabled={false}
              value={""}
              maxlength="100"
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "socialLeadId" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="socialLeadId"
              label="Social Lead ID"
              placeholder="Enter Social Lead ID"
              optional={data?.isRequired}
              disabled={false}
              value={""}
              maxlength="70"
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "description" ? (
          <div className="lead-capture-form-main-element-section">
            <InputLabel>
              {data?.isRequired ? "Description *" : "Description"}
            </InputLabel>
            <DescriptionInputComponent
              fieldName="description"
              label="Company Description"
              placeholder="Add Description"
              optional={data?.isRequired}
              disabled={false}
              value={""}
              onChange={(e: any) => {}}
              maxlength={150}
              isRequired={data?.isRequired}
            />
          </div>
        ) : data?.title === "streetAddress" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="streetAddress"
              label="Street Address"
              placeholder="Enter Street Address"
              optional={false}
              disabled={false}
              value={""}
            />
          </div>
        ) : data?.title === "city" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="city"
              label="City"
              placeholder="Enter City"
              optional={false}
              disabled={false}
              value={""}
            />
          </div>
        ) : data?.title === "state" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="state"
              label="State"
              placeholder="Enter State"
              optional={false}
              disabled={false}
              value={""}
            />
          </div>
        ) : data?.title === "country" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="country"
              label="Country"
              placeholder="Enter Country"
              optional={false}
              disabled={false}
              value={""}
            />
          </div>
        ) : data?.title === "zipcode" ? (
          <div className="lead-capture-form-main-element-section">
            <TextInputComponent
              type="text"
              fieldName="zipcode"
              label="Zipcode"
              placeholder="Enter Zipcode"
              optional={false}
              disabled={false}
              value={""}
            />
          </div>
        ) : data?.title === "address" ? (
          <div className="lead-capture-form-main-element-address-section">
            <div className="lead-capture-form-main-element-address-section-title">
              Address Information {data?.isRequired ? `*` : ""}
            </div>
            <div className="lead-capture-form-main-element-section-sub">
              <div className="lead-capture-form-main-element-section">
                <TextInputComponent
                  type="text"
                  fieldName="streetAddress"
                  label="Street Address"
                  placeholder="Enter Street Address"
                  optional={false}
                  disabled={false}
                  value={""}
                  isRequired={data?.isRequired}
                />
              </div>
              <div className="lead-capture-form-main-element-section">
                <SelectInputComponent
                  fieldName="city"
                  label="City"
                  placeholder="Enter City"
                  optional={false}
                  disabled={false}
                  value={""}
                  isRequired={data?.isRequired}
                />
              </div>
              <div className="lead-capture-form-main-element-section">
                <SelectInputComponent
                  fieldName="state"
                  label="State"
                  placeholder="Enter State"
                  optional={false}
                  disabled={false}
                  value={""}
                  isRequired={data?.isRequired}
                />
              </div>
              <div className="lead-capture-form-main-element-section">
                <SelectInputComponent
                  fieldName="country"
                  label="Country"
                  placeholder="Enter Country"
                  optional={false}
                  disabled={false}
                  value={""}
                  isRequired={data?.isRequired}
                />
              </div>
              <div className="lead-capture-form-main-element-section">
                <SelectInputComponent
                  fieldName="zipcode"
                  label="Zipcode"
                  placeholder="Enter Zipcode"
                  optional={false}
                  disabled={false}
                  value={""}
                  isRequired={data?.isRequired}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default LeadCaptureFormElements;
